import { render, staticRenderFns } from "./ep_rate.vue?vue&type=template&id=2f065ee6&scoped=true"
import script from "./ep_rate.vue?vue&type=script&lang=js"
export * from "./ep_rate.vue?vue&type=script&lang=js"
import style0 from "./ep_rate.vue?vue&type=style&index=0&id=2f065ee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f065ee6",
  null
  
)

export default component.exports